export const FORMAT_AP_STYLE_GUIDE_INSTRUCTIONS = 'ap_style_guide';
export const FORMAT_AP_STYLE_GUIDE_INSTRUCTIONS_DESCRIPTION =
  'Follow all AP Style guidelines, including concise language, avoiding Oxford commas, proper attribution, numeral usage, title capitalization, dates, addresses, state abbreviations, quotation formatting, hyphenation rules, and any other standards outlined by AP Style.';

export const isAPStyleGuideFormat = (format) =>
  format.autoGenerated && format.instructions === FORMAT_AP_STYLE_GUIDE_INSTRUCTIONS;
